import { createSlice } from '@reduxjs/toolkit';
import LOCALES from '../../constants/locales';

const SANDBOX_ENV = 'sandbox';

const initialState = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  contact: '',
  imageSrc: '',
  authenticated: false,
  loaded: false,
  accessMap: {},
  products: [],
  isSandboxEnv: process.env.REACT_APP_STAGE === SANDBOX_ENV,
  userSigningOut: false,
  selectedLocale: LOCALES.EN_IN,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    update: (state, { payload }) => ({ ...state, ...payload }),
    authenticate: (state) => ({ ...state, authenticated: true }),
    invalidate: (state) => ({ ...state, authenticated: false }),
    updateUserLoaded: (state, { payload }) => ({ ...state, loaded: payload }),
    updateUserSigningOut: (state, { payload }) => {
      state.userSigningOut = payload;
    },
    updateUserLocale: (state, { payload }) => ({ ...state, selectedLocale: payload }),
    updateAccessMap: (state, { payload }) => ({ ...state, accessMap: payload }),
    reset: () => initialState,
  },
});

export const {
  update: updateUser,
  reset: resetUser,
  authenticate: authenticateUser,
  invalidate: invalidateUser,
  updateUserLoaded,
  updateAccessMap,
  updateUserSigningOut,
  updateUserLocale,
} = userSlice.actions;

export default userSlice.reducer;
